export default __webpack_public_path__ + "static/media/1251.b66fed3e.png";